import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency: string = 'USD'): string {
  const localeMap: Record<string, string> = {
    BRL: 'pt-BR',
    USD: 'en-US',
    EUR: 'de-DE',
  }
  
  return new Intl.NumberFormat(localeMap[currency] || 'en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

export function formatBRL(cents: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(cents / 100)
}

const CURRENCY_LOCALE: Record<string, string> = {
  BRL: 'pt-BR',
  USD: 'en-US',
  EUR: 'de-DE',
}

// Format an integer amount of minor units (cents) in the given ISO currency.
// Extra seats bill in the tenant's own currency (BRL/USD/EUR), so money shown in
// the seat-billing UI must follow the currency reported by the server, not a
// hardcoded one.
export function formatMoneyCents(cents: number, currency: string = 'BRL'): string {
  const code = (currency || 'BRL').toUpperCase()
  return new Intl.NumberFormat(CURRENCY_LOCALE[code] ?? undefined, {
    style: 'currency',
    currency: code,
  }).format(cents / 100)
}
